import { render, staticRenderFns } from "./settings-company-employees.vue?vue&type=template&id=35e1908e&"
import script from "./settings-company-employees.ts?vue&type=script&lang=ts&"
export * from "./settings-company-employees.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports